import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow, IconButton } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const StyledTopicWrapper = styled(FlexRow)<{ isLoading: boolean }>`
    position: relative;
    height: 46px;
    padding: 16px;
    margin-bottom: 8px;
    background: ${carbon[0]};
    border: 1px solid ${carbon[50]};
    border-radius: 3px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    &:hover {
        box-shadow: 0 18px 34px 0 rgba(14, 30, 62, 0.12);

        ${({ isLoading }) =>
            isLoading
                ? css`
                      cursor: not-allowed;
                  `
                : css`
                      z-index: 99;
                      border: 1px solid ${carbon[100]};
                      cursor: pointer;
                  `}
    }
`;

export const StyledIcon = styled(FlexRow)`
    box-sizing: border-box;
    border: 1px solid ${carbon[50]};
    border-radius: 6px;
    height: 32px;
    width: 32px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const StyledSeparator = styled.div`
    height: 40px;
    border-right: 1px solid ${carbon[100]};
`;

export const StyledTopicName = styled.span`
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${setFontVariant("subtitle1", carbon[500])};

    @media (min-width: 1439px) {
        max-width: 308px;
    }

    @media (min-width: 1919px) {
        max-width: 500px;
    }
`;

export const StyledTopicMetaData = styled(FlexRow)`
    box-sizing: border-box;
    height: 100%;
    width: 20.8%;
    align-items: center;
    justify-content: start;
    gap: 16px;

    @media (max-width: 1280px) {
        gap: 8px;
    }

    @media (min-width: 1439px) {
        width: 32.3%;
    }

    @media (min-width: 1919px) {
        width: 37.6%;
    }
`;

export const StyledColumn = styled(FlexColumn)`
    max-width: 100%;
    box-sizing: border-box;
`;

export const StyledTopicGroup = styled(FlexRow)`
    box-sizing: border-box;
    gap: 8px;
    align-items: center;

    @media (max-width: 1280px) {
        gap: 4px;
    }
`;

export const StyledTopicKeywords = styled(FlexRow)`
    ${setFontVariant("body2", carbon[300])}
`;

export const StyledVolume = styled(FlexRow)`
    width: 28%;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    .customChangeIndication {
        padding: 8px;
    }

    @media (min-width: 1439px) {
        width: 24%;
    }
    @media (min-width: 1919px) {
        width: 19.8%;
    }
`;

export const StyledShareWrapper = styled(FlexRow)`
    box-sizing: border-box;
    width: 14.4%;

    @media (min-width: 1439px) {
        width: 12.3%;
    }
    @media (min-width: 1919px) {
        width: 9.5%;
    }
`;

export const StyledIconLoader = styled(FlexRow)`
    border: 0;
    border-radius: 50%;
    box-shadow: none;
    background-color: rgba(181, 190, 198, 0.2);
    padding: 0;
    height: 40px;
    width: 40px;
    align-items: center;
`;

export const StyledExcelIconButton = styled(IconButton)`
    & .SWReactIcons svg path {
        fill: ${carbon[100]};
    }
`;
